import React, { useState } from "react";

export const ShowMoreText = ({ characters, text, ...rest }) => {
    const [showMore, setShowMore] = useState(false);

    // keep tag open if p has style or other html attributes
    const splitFirstP = text.split("<p");

    const countBeforeFirstP = splitFirstP[0].length;
    const getTextToSplit = `${text.substring(countBeforeFirstP)}`;

    return (
        <div {...rest}>
            <div dangerouslySetInnerHTML={{ __html: splitFirstP[0] }} />
            <div
                className={!showMore ? "show-more-text" : ""}
                dangerouslySetInnerHTML={{ __html: getTextToSplit }}
            />
            {!showMore ? (
                <button
                    className="show-more-btn"
                    onClick={() => setShowMore(!showMore)}
                >
                    En savoir +
                </button>
            ) : null}
        </div>
    );
};

export default ShowMoreText;